export default [
  // AFTER INTRO
  {m:26, t: 8, pos: 2},
  {m:26, t: 8.5, pos: 3},

  {m:27, t: 1, pos: 4, hold: 7},
  // {m:27, t: 2, pos: 4},
  // {m:27, t: 3, pos: 2},
  // {m:27, t: 4, pos: 1},
  // {m:27, t: 5, pos: 5},
  // {m:27, t: 6, pos: 2},
  // {m:27, t: 7, pos: 4},
  {m:27, t: 8, pos: 2},

  {m:28, t: 1, pos: 5},
  {m:28, t: 2, pos: 4, hold: 2},
  // {m:28, t: 3, pos: 2},
  {m:28, t: 4, pos: 2, hold: 3},
  // {m:28, t: 5, pos: 5},
  // {m:28, t: 6, pos: 5},
  // {m:28, t: 7, pos: 0}, // off
  // {m:28, t: 8, pos: 0},


  {m:29, t: 1, pos: 1, hold: 8}, {m:29, t: 1, pos: 2, hold: 8}, {m:29, t: 1, pos: 4, hold: 8},
  // {m:29, t: 2, pos: 4},
  // {m:29, t: 3, pos: 2},
  // {m:29, t: 4, pos: 1},
  // {m:29, t: 5, pos: 5},
  // {m:29, t: 6, pos: 2},
  // {m:29, t: 7, pos: 4},
  // {m:29, t: 8, pos: 2},


  {m:30, t: 1, pos: 4},
  {m:30, t: 2, pos: 2},
  {m:30, t: 3, pos: 1},
  {m:30, t: 4, pos: 4, hold: 2},
  // {m:30, t: 5, pos: 4},
  {m:30, t: 6, pos: 2, hold: 3},
  // {m:30, t: 7, pos: 4},
  // {m:30, t: 8, pos: 2},

  {m:31, t: 1, pos: 1, hold: 4}, {m:31, t: 1, pos: 2, hold: 4}, {m:31, t: 1, pos: 3, hold: 4},
  // {m:31, t: 2, pos: 4},
  // {m:31, t: 3, pos: 2},
  // {m:31, t: 4, pos: 1},
  {m:31, t: 5, pos: 1, hold: 4}, {m:31, t: 5, pos: 2, hold: 4}, {m:31, t: 5, pos: 3, hold: 4},
  // {m:31, t: 6, pos: 2},
  // {m:31, t: 7, pos: 4},
  // {m:31, t: 8, pos: 2},

  {m:32, t: 1, pos: 1, hold: 6}, {m:32, t: 1, pos: 2, hold: 6}, {m:32, t: 1, pos: 3, hold: 6},
  // {m:32, t: 2, pos: 4},
  // {m:32, t: 3, pos: 2},
  // {m:32, t: 4, pos: 1},
  // {m:32, t: 5, pos: 1},
  // {m:32, t: 6, pos: 2},
  // {m:32, t: 7, pos: 4}, // OFF
  // {m:32, t: 8, pos: 2},

  {m:33, t: 1, pos: 2},
  {m:33, t: 2, pos: 3},
  {m:33, t: 3, pos: 2},
  {m:33, t: 4, pos: 4, hold: 2},
  // {m:33, t: 5, pos: 5},
  {m:33, t: 6, pos: 3},
  {m:33, t: 7, pos: 2},
  {m:33, t: 8, pos: 5, hold: 2},

  // {m:34, t: 1, pos: 2},
  {m:34, t: 2, pos: 3},
  {m:34, t: 3, pos: 2},
  {m:34, t: 4, pos: 3},
  {m:34, t: 5, pos: 5},
  {m:34, t: 6, pos: 4},
  {m:34, t: 7, pos: 3},
  {m:34, t: 8, pos: 2},

  {m:35, t: 1, pos: 1},
  {m:35, t: 2, pos: 2},
  {m:35, t: 3, pos: 1},
  {m:35, t: 4, pos: 3, hold: 2},
  // {m:35, t: 5, pos: 5},
  {m:35, t: 6, pos: 2},
  {m:35, t: 7, pos: 1},
  {m:35, t: 8, pos: 4, hold: 2},

  // {m:36, t: 1, pos: 1},
  {m:36, t: 2, pos: 2},
  {m:36, t: 3, pos: 1},
  {m:36, t: 4, pos: 3, hold: 2},
  // {m:36, t: 5, pos: 5},
  {m:36, t: 6, pos: 2},
  {m:36, t: 7, pos: 1},
  {m:36, t: 8, pos: 2},

  {m:37, t: 1, pos: 1},
  {m:37, t: 2, pos: 2},
  {m:37, t: 3, pos: 3},
  {m:37, t: 4, pos: 2},
  {m:37, t: 5, pos: 1},
  {m:37, t: 6, pos: 3},
  {m:37, t: 7, pos: 2},
  {m:37, t: 8, pos: 1},

  {m:38, t: 1, pos: 4},
  {m:38, t: 2, pos: 2},
  {m:38, t: 3, pos: 1},
  {m:38, t: 4, pos: 3, hold: 2},
  // {m:38, t: 5, pos: 1},
  {m:38, t: 6, pos: 2},
  {m:38, t: 7, pos: 1, hold: 2},
  // {m:38, t: 8, pos: 1},

  {m:39, t: 1, pos: 1},
  {m:39, t: 2, pos: 2},
  {m:39, t: 3, pos: 3},
  {m:39, t: 4, pos: 4, hold: 2},
  // {m:39, t: 5, pos: 1},
  {m:39, t: 6, pos: 3},
  {m:39, t: 7, pos: 2},
  {m:39, t: 8, pos: 5, hold: 2},

  // {m:40, t: 1, pos: 1},
  {m:40, t: 2, pos: 3},
  {m:40, t: 3, pos: 2},
  {m:40, t: 4, pos: 2},
  {m:40, t: 5, pos: 4},
  {m:40, t: 6, pos: 3},
  {m:40, t: 7, pos: 2},
  {m:40, t: 8, pos: 2},
];



//////////////////
// WEBPACK FOOTER
// ./lib/songs/song_verse_1.js
// module id = 10
// module chunks = 0